enum UserPlaceRole {
	OWNER = 'owner',
	ADMIN = 'admin',
	EMPLOYEE = 'employee',
}

export default UserPlaceRole;